// removed by extract-text-webpack-plugin
module.exports = {"order-item-list":"order-item-list__3mcb5","order-header":"order-header__3uVLn","order-item-row":"order-item-row__1Ehs6","cols":"cols__1iMIA","no-status":"no-status__ZBmta"};


//////////////////
// WEBPACK FOOTER
// ./styles/dashboard/orderItemModal.scss
// module id = 1163
// module chunks = 68